import { getLangSync, loadLang } from './langResources';
import { safeGetItem } from '../lib/safeStorage';
// IMP-438: 언어 코드 해석은 currentLang.js SSoT — 날짜 포맷 등 비-번역 소비처가 이 모듈을
//   import 하지 않아도 되게 분리했다(모듈 전체를 수동 모킹하는 테스트가 172개 있어, 그 경로에
//   포맷 의존성이 얹히면 조용히 깨진다). 로직 정의는 currentLang.js 한 곳뿐이다.
import { resolveCurrentLangCode } from './currentLang';

const langEn = getLangSync('eng');

let _cachedLangCode = null;
let _cachedLangFile = null;

const getCurrentLangFile = () => {
    const langCode = resolveCurrentLangCode();
    if (langCode === _cachedLangCode && _cachedLangFile) return _cachedLangFile;
    _cachedLangCode = langCode;
    if (!langCode) {
        // 언어 미설정 user 또는 코드 해석 실패 — 기존 동작(영어) 유지, loadLang 호출 없이 캐시
        _cachedLangFile = langEn;
        return langEn;
    }
    // IMP-438 리뷰 Minor: 언어 코드 해석이 currentLang.js 로 빠지면서 이 구간을 감싸던 외곽
    // try/catch 도 함께 사라졌다. getLangSync 는 단순 조회라 throw 하지 않지만 loadLang 은
    // 동적 import 를 호출하므로 번들러/런타임에 따라 동기 throw 가능성이 남는다. 번역 렌더 전체가
    // 죽지 않도록 다시 감싸되, 폴백은 기존 catch 의 undefined 가 아니라 langEn 으로 둔다
    // (undefined 를 반환하면 호출부가 그대로 deref 해 흰 화면이 된다 — 기존 catch 의 결함).
    try {
        const file = getLangSync(langCode);
        if (file) {
            _cachedLangFile = file;
            return _cachedLangFile;
        }
        _cachedLangFile = null;
        loadLang(langCode); // 미로드 언어 — 백그라운드 self-heal, 이번 호출은 영어 fallback
    } catch (e) {
        _cachedLangFile = null;
        console.warn('[Translate/currentLang] lang file load failed, fallback to eng', { langCode, e });
    }
    return langEn;
};

// DB 번역 데이터 캐시 — raw 문자열이 바뀔 때만 Map 재빌드 (JSON.parse 반복 방지)
let _dbCacheRaw = null;
let _dbCacheMap = null;     // Map<title, record> — fallback (기존 동작 유지)
let _dbCacheLangMap = null; // Map<`title:lang`, record> — 언어별 우선 조회

const getDbTranslateMap = () => {
    const raw = safeGetItem('translate');
    if (!raw || raw === 'undefined') return null;
    if (_dbCacheRaw === raw) return _dbCacheMap;
    try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) {
            const map = new Map();
            const langMap2 = new Map();
            parsed.forEach(item => {
                if (item && item.title && !item.isDel) {
                    map.set(item.title.trim(), item); // fallback (last-write-wins 기존 동작)
                    if (item.language) langMap2.set(item.title.trim() + ':' + item.language, item);
                }
            });
            _dbCacheRaw = raw;
            _dbCacheMap = map;
            _dbCacheLangMap = langMap2;
            return map;
        }
    } catch (e) {
        console.warn('[Translate] Failed to parse translate data:', e);
    }
    return null;
};

export const Translate = (title) => {
    // getCurrentLangFile() 먼저 호출 → _cachedLangCode 캐시 갱신 (DB 조회 시 재사용)
    const currentLang = getCurrentLangFile();

    // 1. DB (localStorage 'translate') — 어드민 커스텀 번역 우선
    const dbMap = getDbTranslateMap();
    if (dbMap && _dbCacheLangMap) {
        // _cachedLangCode: getCurrentLangFile()이 이미 갱신한 캐시 재사용 (localStorage 재파싱 없음)
        const langCode = _cachedLangCode || 'eng';
        const dbResult = _dbCacheLangMap.get(title + ':' + langCode);
        if (dbResult && dbResult.contents && !dbResult.contents.startsWith('[TODO:translate]')) {
            return dbResult.contents;
        }
        // 현재 언어 DB 레코드 없음 → JSON으로 fallback (다른 언어 레코드 사용 안 함)
    }

    // 2. JSON static file — 언어별 기본 번역 (lang.*.json)
    if (title in currentLang) {
        const value = currentLang[title];
        // [TODO:translate] 접두어가 있으면 영어로 fallback
        if (value.startsWith('[TODO:translate]')) {
            if (langEn[title]) return langEn[title];
            return value.replace('[TODO:translate] ', '') || title;
        }
        return value;
    }

    // 3. Fallback: 영어 lang 파일에서 직접 조회
    if (langEn[title]) return langEn[title];

    return title;
};

